import React, { useState } from 'react';

import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiExpandedMoreIcon from '@material-ui/icons/ExpandMoreOutlined';
import MuiBox from '@material-ui/core/Box';
import MuiTypography from '@material-ui/core/Typography';
import MuiGrid from '@material-ui/core/Grid';
import MuiMusicIcon from '@material-ui/icons/MusicNoteSharp';
import TrackSplitDetails from './TrackSplitDetails';

export default function TrackSplits({ accountTracks }) {
  const [expandedList, setExpandedList] = useState([]);

  function toggleAccordian(index) {
    if (expandedList.includes(index)) return setExpandedList(expandedList.filter(i => i != index));
    return setExpandedList([...expandedList, index]);
  }

  return (
    <MuiBox>
      {accountTracks.map((aT, i) => (
        <MuiAccordion expanded={expandedList.includes(i)} key={aT.id} onChange={() => toggleAccordian(i)}>
          <MuiAccordionSummary expandIcon={<MuiExpandedMoreIcon />}>
            <MuiGrid container spacing={1}>
              <MuiGrid item xs={10}>
                <MuiMusicIcon /> <span style={{ fontWeight: 'bold' }}>{aT.track.title} - </span>
                <span>
                  {aT.track.trackParties
                    .filter(tp => tp.roles.includes('MainArtist'))
                    .map(tp => tp.party.full_name)
                    .join(', ')}
                </span>
              </MuiGrid>
              <MuiGrid item xs={2}>
                <MuiTypography style={{ fontWeight: 'bold' }}>{aT.track.isrc}</MuiTypography>
              </MuiGrid>
            </MuiGrid>
          </MuiAccordionSummary>
          <TrackSplitDetails splits={aT.track.stakeholderTrackSplits} s />
        </MuiAccordion>
      ))}
    </MuiBox>
  );
}
